import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { Modal } from 'apps/modals/views/modal';
import { modalStore } from 'apps/modals/app';
import { MenuOption } from 'legacyComponents/layout/menuOption';
import { ModalTitle, Divider, Center } from 'legacyComponents/styled/lib';
import Button from 'components/Button';

import { conf } from 'apps/repository/config.yaml';

@observer
export class SelectTemplateModal extends Modal {
  selectTemplate = template => {
    // Check if the template is composed of sections
    if (template.advancedTemplate && template.sections) {
      modalStore.props.readmeApp.OpenSubtemplates(template);
    } else {
      // The template is a simple one, just load it
      modalStore.props.readmeApp.ChooseTemplate(template);
      modalStore.ClearComponent();
    }
  };

  onSelectedTemplate = template => {
    this.selectTemplate(template);
  };

  render() {
    const templates = [];

    const options_keys = Object.keys(conf.templates);

    for (let i = 0; i < options_keys.length; i += 1) {
      const template = conf.templates[options_keys[i]];

      templates.push(
        <TemplateOption
          link={template.link}
          title={template.title}
          id={template.title}
          icon='story'
          description={template.description}
          key={template.title}
          template={template}
          onclick={() => {
            this.onSelectedTemplate(template);
          }}
        />,
      );
    }

    return (
      <div>
        <SelectTemplateTitle>{'Choose a Template'}</SelectTemplateTitle>
        <Divider />
        {templates}

        <Center>
          <Button
            outline
            margin='2rem 0 0 0'
            text='Cancel'
            onClick={this.props.clickCancel}
          />
        </Center>
      </div>
    );
  }
}

SelectTemplateModal.propTypes = {
  fadeIn: PropTypes.func,
  clickCancel: PropTypes.func,
};

const SelectTemplateTitle = styled(ModalTitle)`
  font-family: HelveticaNowDisplay;
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 126%;
`;

const TemplateOption = styled(MenuOption)`
  font-family: HelveticaNowDisplay;
  font-style: normal;
  font-weight: normal;
  h2 {
    font-size: 24px;
    line-height: 126%;
    color: red;
  }
  h3 {
    font-size: 16px;
    line-height: 24px;
    color: #3d3d3d;
  }
`;
